import { createAppStore } from '@store/createAppStore';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';

import type { FeedbackDockSideT, FeedbackStateT, FeedbackTypeT } from './types';

const DOCK_SIDE_KEY = 'atg-feedback-dock-side';

const readDockSide = (): FeedbackDockSideT =>
  localStorage.getItem(DOCK_SIDE_KEY) === 'left' ? 'left' : 'right';

export const defaultFeedbackState: FeedbackStateT = {
  open: false,
  feedbackType: 'Idea',
  text: '',
  componentSource: undefined,
  screenshot: undefined,
  screenshotPreviewUrl: '',
  capturingScreenshot: false,
  allowContact: true,
  submitting: false,
  submittedKey: '',
  rateLimited: false,
  dockSide: readDockSide(),
};

export const [feedbackStore, setFeedbackStore, resetFeedbackStore] =
  createAppStore<FeedbackStateT>({ ...defaultFeedbackState }, 'feedbackStore');

const releasePreview = () => {
  if (feedbackStore.screenshotPreviewUrl !== '') {
    URL.revokeObjectURL(feedbackStore.screenshotPreviewUrl);
  }
};

export const setFeedbackScreenshot = (screenshot: File | undefined) => {
  releasePreview();
  setFeedbackStore({
    screenshot,
    screenshotPreviewUrl:
      screenshot === undefined ? '' : URL.createObjectURL(screenshot),
  });
};

export const setFeedbackPanelOpen = (
  feedbackType: FeedbackTypeT,
  componentSource: ChangeTrackingSource | undefined,
) => {
  releasePreview();
  setFeedbackStore({
    open: true,
    feedbackType,
    componentSource,
    text: '',
    screenshot: undefined,
    screenshotPreviewUrl: '',
    capturingScreenshot: false,
    allowContact: true,
    submitting: false,
    submittedKey: '',
    rateLimited: false,
  });
};

export const closeFeedbackPanel = () => {
  releasePreview();
  setFeedbackStore({
    open: false,
    text: '',
    screenshot: undefined,
    screenshotPreviewUrl: '',
    capturingScreenshot: false,
    submitting: false,
    submittedKey: '',
    rateLimited: false,
    componentSource: undefined,
  });
};

export const setFeedbackDockSide = (dockSide: FeedbackDockSideT) => {
  localStorage.setItem(DOCK_SIDE_KEY, dockSide);
  setFeedbackStore({ dockSide });
};
